'use client';

import { Tooltip as HeroTooltip } from '@heroui/react';
import { ReactNode } from 'react';

export interface TooltipProps {
  children: ReactNode;
  delay?: number;
  closeDelay?: number;
}

const TooltipRoot = ({ children, delay = 0, closeDelay = 0 }: TooltipProps) => {
  return (
    <HeroTooltip delay={delay} closeDelay={closeDelay}>
      {children}
    </HeroTooltip>
  );
};

const Trigger = ({ children }: { children: ReactNode }) => (
  <HeroTooltip.Trigger>{children}</HeroTooltip.Trigger>
);

const Content = ({
  children,
  showArrow,
  placement,
  className,
}: {
  children: ReactNode;
  showArrow?: boolean;
  placement?:
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'top start'
    | 'top end'
    | 'bottom start'
    | 'bottom end';
  className?: string;
}) => (
  <HeroTooltip.Content
    showArrow={showArrow}
    placement={placement}
    className={className}
  >
    {children}
  </HeroTooltip.Content>
);

const Arrow = () => <HeroTooltip.Arrow />;

export const Tooltip = Object.assign(TooltipRoot, {
  Trigger,
  Content,
  Arrow,
});
